export default __webpack_public_path__ + "static/media/bernay.65c324aa.jpg";